import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Panel, PanelHeader } from "../Layout/Panel";
import { checkIsUserAuthorized, roles } from "../../helpers/Authorization/authorizationHelpers";
import { getNotificationsSelector } from "../../selectors/selectors";
import ManageNotificationCard from "../Layout/Notifications/ManageNotificationCard";
import NoNotificationCard from "../Layout/Notifications/NoNotificationCard";
import NotificationCard from "../Layout/Notifications/NotificationCard";

class NotificationList extends PureComponent {
  static propTypes = {
    contentClass: PropTypes.string,
    isMobile: PropTypes.bool,
    notifications: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    contentClass: "",
    isMobile: false,
    notifications: [],
    userMetadata: {}
  };

  get contentProps() {
    return { className: classNames("list__content", this.props.contentClass, "--scrollable") };
  }

  render() {
    const notifications = this.props.notifications.map(notification => (
      <NotificationCard notification={notification} key={notification.id} userMetadata={this.props.userMetadata} />
    ));
    if (_.isEmpty(notifications)) {
      notifications.push(<NoNotificationCard key="no-notification" />);
    }

    return (
      <Panel className="notification-list">
        <PanelHeader id={i18n.t("notification.notifications")} isMobile={this.props.isMobile} />
        <div className="notification-list__container">
          {notifications}
          {checkIsUserAuthorized(roles.InternalExpert) ? <ManageNotificationCard /> : null}
        </div>
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    isMobile: state.app.isMobile,
    notifications: getNotificationsSelector(state),
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  {}
)(NotificationList);



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationList.js